export const BASE_URL =
  process.env.NODE_ENV == "development" ? "/api" : "/gateway";
export const TIME_OUT = 1000 * 30;
export const AES_KEY = "7PrQDcu7FBGFpBPE";
export const AES_IV = "tBdY1UqoCLMewDog";
